import momentJalaali from "moment-jalali";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { searchCommands, deleteCommand } from "../Services/store/api/CommandsAPI";
import { setDialog } from "../Services/store/api/GetAllProduct";
import { EyeFill, EyeSlashFill, Link45deg, List, Paperclip, Search } from "react-bootstrap-icons";
import { downloadFile } from "../Services/store/api/Services";
import DatePicker from "react-datepicker2";
import BihamtaTable from "../Components/BihamtaTable";
import { useForm } from "react-hook-form";
import { keyIsLetterOrNumber, setErrorDialog } from "../store/api/CommonFunctions";
import ModalSelectUser from "../Components/Modals/ModalSelectUser";
import ModalCommands from "../Components/Modals/ModalCommands";
const SearchCommands = () => {
    const { register, handleSubmit } = useForm();
    const [showFilter, setShowFilter] = useState(true);
    const [dateFilters, setDateFilters] = useState({});
    const [popUser, setPopUser] = useState({ show: false });
    const [selectedUser, selectUser] = useState(null);
    const [popCommand, setPopCommand] = useState({ show: false });
    const filterData = useSelector(state => state.CommandsReducer.commandsFilter);
    const dispatch = useDispatch();
    useEffect(() => {
        document.body.classList = "notMain";
    }, []);
    const search = (data) => {
        data.Skip = 0;
        data.Take = 10;
        if (document.getElementsByName("dateFrom")[0].value !== "") {
            data.CreationDateFrom = dateFilters.CreationDateFrom;
        }
        if (document.getElementsByName("dateTo")[0].value !== "") {
            data.CreationDateTo = dateFilters.CreationDateTo;
        }
        dispatch(searchCommands(data));
    }
    const history = useHistory();
    function showCommand(cmd) {
        setPopCommand({
            show: true,
            attachmentType: cmd.AttachmentType,
            attachmentID: cmd.AttachmentID,
            id: cmd.ID,
            onAddEdit: () => dispatch(searchCommands(filterData))
        })
    }
    const showRelated = (cmd) => {
        if (!(Number(cmd.AttachmentID) > 0)) {
            return;
        }
        if (cmd.AttachmentType === "repair" || cmd.AttachmentType === "install") {
            history.push(`/Services/Service/${cmd.AttachmentID}/${cmd.AttachmentType}`, null);
        }
        else if (cmd.AttachmentType === "customer") {
            window.open(`/CRM/AddEditCustomer/${cmd.AttachmentID}`);
        }
        else if (cmd.AttachmentType === "AccountingDocument") {
            window.open(`/Accounting/AddEditDocument/${cmd.AttachmentID}`);
        }
        else if(cmd.AttachmentType?.includes("Invoice"))
        {
            const invoiceType =cmd.AttachmentType.replace("Invoice","").replace("Formal","");
            const isFormal = cmd.AttachmentType.includes("Formal");
            window.open(`/Sale/Invoice/${invoiceType}/${cmd.AttachmentID}/${isFormal}`);
        }
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function showModalUser(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
        }
        setPopUser({
            show: true,
            selectUserWithName: selectUser
        })
    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "موضوع", colName: "Subject", showInMobile: true, colType: "string", maxTextLength: 20, hasTooltip: true },
        { colTitle: "متن پیام", colName: "FirstMessage", showInMobile: true, colType: "string", maxTextLength: 150, hasTooltip: true },
        { colTitle: "اولویت", colName: "PriorityName", showInMobile: true },
        { colTitle: "تاریخ ایجاد", colName: "pCreationDate", showInMobile: false },
        { colTitle: "تاریخ یادآوری", colName: "pAlarmDate", showInMobile: false },
        { colTitle: "ایجاد کننده", colName: "CreateByName", showInMobile: false },
        { colTitle: "تعداد پاسخ ها", colName: "MessageCounts", showInMobile: false, colType: "number" }
    ]
    const tableRowButtons = [
        {
            title: "نمایش دستور", type: "show", className: "group-Btn-smalll btn-success", onclick: (item) => showCommand(item)
        },
        {
            title: "پیوست", tooltip: "پیوست", type: "common", icon: <Paperclip color="blue" size={18} />, className: "group-Btn-smalll btn-primary", showCondition: (item) => item.FirstMessageHasAttach,
            onclick: (item) => { downloadFile(item.FirstMessageID, "command", (msg) => setErrorDialog(dispatch, msg, "دانلود فایل")) }
        },
        {
            title: "فرم مرتبط", tooltip: "فرم مرتبط", type: "common", icon: <Link45deg color="green" size={18} />, className: "group-Btn-smalll btn-secondary", showCondition: (item) => item.AttachmentType && Number(item.AttachmentID) > 0,
            onclick: (item) => { showRelated(item) }
        },
        {
            title: "حذف دستور", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف دستور کار',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteCommand(item.ID, () => { dispatch(searchCommands(filterData)) })
                }))
            }
        }

    ]
    useEffect(() => {
        if (filterData?.CreationDateFrom || filterData?.CreationDateTo) {
            setDateFilters({
                CreationDateFrom: filterData.CreationDateFrom,
                CreationDateTo: filterData.CreationDateTo
            })
        }
    }, [])
    return (<div className="container-fluid mt-1" style={{ minHeight: '80vh' }}>
        <br />
        <Card>
            <Card.Header className="headerStyle">جستجوی دستور کار</Card.Header>
            <Card.Body className="bodyStyle">
                <ModalSelectUser popData={popUser} setUserPop={setPopUser} />
                <ModalCommands popData={popCommand} setPopData={setPopCommand} />
                <form onSubmit={handleSubmit(search)}>
                    <Row className="rowBorder" id="divFilters" >
                        <div className="rowTitle">
                            فیلترهای جستجو
                            &nbsp;
                            {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                            {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                        </div>
                        <Col md={2} className='form-group'>
                            <input placeholder='موضوع ' type='text' className='form-control' name="Subject" defaultValue={filterData?.Subject ?? ""} ref={register({})}></input>
                        </Col>
                        <Col md={2} className='form-group'>
                            <input placeholder='متن پیام ' type='text' className='form-control' name="Message" defaultValue={filterData?.Message ?? ""} ref={register({})}></input>
                        </Col>
                        <Col md={2} className="form-group">
                            <DatePicker placeholder='تاریخ ایجاد از' isGregorian={false} timePicker={false} className="form-control" name="dateFrom"
                                onChange={value => setDateFilters({ ...dateFilters, CreationDateFrom: value.local("en").format("YYYY-MM-DD") })} value={dateFilters?.CreationDateFrom ? momentJalaali(dateFilters?.CreationDateFrom) : null} />
                        </Col>
                        <Col md={2} className="form-group">
                            <DatePicker placeholder='تاریخ ایجاد تا' isGregorian={false} timePicker={false} className="form-control" name="dateTo"
                                onChange={value => setDateFilters({ ...dateFilters, CreationDateTo: value.local("en").format("YYYY-MM-DD") })} value={dateFilters?.CreationDateTo ? momentJalaali(dateFilters?.CreationDateTo) : null} />
                        </Col>
                        <Col md={2} className="form-group">
                            <input type="hidden" name="CreateByID" value={selectedUser?.ID ?? ""} ref={register({})} />
                            <Form.Control placeholder="ثبت کننده" readOnly value={selectedUser?.Name ?? ""} onKeyDown={showModalUser} />
                            <Button className="btn-input-tiny" style={{ top: "8px" }} onClick={showModalUser}><List size={21} /></Button>
                        </Col>
                        <Col md={2} className="form-group">
                            <select className="form-control" name="OrderBy" ref={register({})}>
                                <option value="">مرتب سازی براساس</option>
                                <option value="Date">تاریخ-صعودی</option>
                                <option value="Date Desc">تاریخ-نزولی</option>
                                <option value="Priority">اولویت-صعودی</option>
                                <option value="Priority Desc">اولویت-نزولی</option>
                            </select>
                        </Col>
                    </Row>
                    <div>
                        <Button type="submit" className="mt-2 group-Btn" ><Search size={15} />&nbsp;جستجوی دستور کار</Button>
                    </div>
                </form>
                <BihamtaTable rowButtons={tableRowButtons} columns={tableColes} reducerName="CommandsReducer" objectName="commandList" hasPaging={true}
                    searchMethod={(data) => dispatch(searchCommands(data))} filterData={filterData} style={{ whiteSpace: "nowrap" }} />
            </Card.Body>

        </Card>
    </div>
    );
}
export default SearchCommands;